core-breadcrumb {
  display: inline-flex;
}

.core-breadcrumb-list {
  display: inline-flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.core-breadcrumb-list .core-breadcrumb-item-wrapper {
  display: inline-flex;
  align-items: center;
}

.core-breadcrumb-list li {
  display: flex;
  align-items: center;
  color: var(--color-neutral-content-medium);
}
